import AsyncStorage from '@react-native-async-storage/async-storage';
import {configureStore} from '@reduxjs/toolkit';
import {
  createTransform,
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import {initialState} from 'src/redux/initialState';
import {rootReducer} from 'src/redux/rootReducer';

//hasAnnouncementsShownThisLaunch shouldn't be persisted
const announcementsTransform = createTransform(
  (inboundState: RootState, key) => {
    if (key === 'campusLocation') {
      const {hasAnnouncementsShownThisLaunch, ...rest} = inboundState || {};
      return rest;
    }
    return inboundState;
  },
  (outboundState: RootState, key) => {
    if (key === 'campusLocation') {
      return {
        ...outboundState,
        hasAnnouncementsShownThisLaunch: false,
      };
    }
    return outboundState;
  },
);

const persistConfig = {
  key: 'root',
  blacklist: ['screen', 'firebaseConfig'],
  storage: AsyncStorage,
  stateReconciler: autoMergeLevel2,
  transforms: [announcementsTransform],
};

export const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  preloadedState: initialState,
});

const persistor = persistStore(store);

export type StoreType = typeof store;
export type RootState = ReturnType<StoreType['getState']>;
export type AppDispatch = StoreType['dispatch'];
export {store, persistor};
